<div class="lsos-logo__container d-flex">
  <svg
    class="lsos-logo__svg"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="50%"
    viewBox="0 0 2500 833"
    enable-background="new 0 0 2500 833"
    xml:space="preserve"
  >
    <path
      stroke="none"
      d="
M1570.000000,834.000000 
	C1046.666748,834.000000 523.833435,834.000000 1.000140,834.000000 
	C1.000094,556.333435 1.000094,278.666870 1.000047,1.000215 
	C834.333191,1.000143 1667.666382,1.000143 2500.999512,1.000072 
	C2500.999756,278.666443 2500.999756,556.332886 2501.000000,833.999634 
	C2190.833252,834.000000 1880.666626,834.000000 1570.000000,834.000000 
M941.956360,489.111267 
	C941.828613,488.884308 941.700806,488.657379 941.490967,488.426025 
	C941.490967,488.426025 941.661804,488.401581 941.716370,488.373840 
	C941.716370,488.373840 941.730469,488.369690 941.979919,487.288177 
	C941.986572,483.518768 941.787537,479.734558 942.057129,475.984070 
	C942.333923,472.134399 940.822571,470.249847 936.073792,470.012054 
	C902.063232,469.969757 868.052673,469.927460 834.002869,468.963013 
	C834.002869,404.045654 834.002869,339.128326 834.002869,274.166809 
	C825.613281,274.166809 817.806885,274.166809 809.127136,274.029297 
	C808.751404,275.793671 808.048645,277.557800 808.047241,279.322510 
	C807.991760,348.795959 808.000000,418.269440 808.000000,487.742920 
	C808.000000,489.364624 808.000000,490.986298 808.000000,492.997864 
	C809.009644,492.997864 809.631775,492.997864 810.253906,492.997894 
	C852.071289,492.998596 893.888733,493.021179 935.705872,492.923401 
	C937.464233,492.919281 939.219910,491.794434 941.416931,491.032715 
	C941.555420,490.649384 941.693909,490.266052 941.956360,489.111267 
M1579.050659,636.992126 
	C1575.309204,637.327759 1571.534180,637.451111 1567.832275,638.036743 
	C1553.678467,640.275513 1540.802856,645.901550 1530.260132,655.434937 
	C1506.520264,676.901978 1497.527344,703.788818 1504.109985,735.186401 
	C1509.289185,759.888977 1523.635010,778.272095 1546.211670,789.498108 
	C1562.614258,797.654175 1580.193726,799.585266 1598.467896,797.117859 
	C1619.997803,794.210938 1638.043457,785.294678 1651.379150,768.026672 
	C1668.934448,745.294922 1673.304443,719.982666 1665.082153,692.433289 
	C1655.369629,659.890747 1625.206787,637.548401 1591.619873,636.139160 
	C1587.731079,636.389526 1583.842407,636.639832 1579.050659,636.992126 
M607.931885,424.379364 
	C625.642334,399.397095 643.344299,374.408844 661.066711,349.435089 
	C670.119385,336.678406 679.291016,324.005280 688.250916,311.184021 
	C693.745483,303.321472 699.518982,295.566437 704.109070,287.183746 
	C708.734802,278.735992 703.990356,272.008453 694.305115,272.004150 
	C667.479614,271.992218 640.654053,272.047455 613.828735,271.978821 
	C601.515198,271.947296 590.595276,276.423035 582.723816,285.225830 
	C573.197449,295.879364 565.236694,307.964966 556.908691,319.651917 
	C532.516235,353.882446 508.278809,388.223480 483.978516,422.519775 
	C461.278992,454.556732 438.575562,486.590912 415.876068,518.627869 
	C391.575745,552.924194 367.292755,587.232788 342.974304,621.516174 
	C324.969574,646.898743 306.923523,672.252014 288.889343,697.613708 
	C279.824493,710.361755 270.709351,723.074158 261.681244,735.848145 
	C250.587402,751.544861 239.487839,767.238525 228.542572,783.038696 
	C224.412079,789.001343 224.993423,795.041870 230.382355,798.627563 
	C232.878494,800.288513 236.493515,800.881470 239.608353,800.902283 
	C265.432983,801.074707 291.259369,801.033752 317.084930,800.955444 
	C320.171478,800.946106 323.349182,800.689148 326.324890,799.924927 
	C336.488586,797.314636 345.736847,792.651245 352.574158,784.624329 
	C358.154297,778.073242 362.747009,770.678040 367.740967,763.631165 
	C390.443604,731.595764 413.132355,699.550537 435.828003,667.510193 
	C452.777496,643.581848 469.728363,619.654480 486.681427,595.728699 
	C511.078369,561.297424 535.492065,526.877930 559.871216,492.434052 
	C575.773865,469.966156 591.627747,447.463776 607.931885,424.379364 
M327.495758,348.032043 
	C341.807373,327.728210 356.067474,307.387817 370.442230,287.128754 
	C394.278809,253.534668 418.193787,219.996185 442.066742,186.427887 
	C458.454956,163.384064 474.826019,140.328049 491.208466,117.280113 
	C503.519165,99.960571 515.763550,82.593147 528.181763,65.351021 
	C533.983948,57.295113 534.769531,51.435154 529.280823,47.055984 
	C526.962280,45.206078 523.362915,44.153008 520.334290,44.128162 
	C493.506989,43.908054 466.676819,43.940746 439.848389,44.075123 
	C436.473450,44.092030 432.981323,44.742996 429.752991,45.763157 
	C417.102722,49.760666 407.462555,57.513222 399.969666,68.613205 
	C385.803925,89.598518 371.141968,110.252129 356.510681,130.919312 
	C332.710022,164.538528 308.741730,198.039032 284.893738,231.624802 
	C262.183624,263.608063 239.563995,295.655548 216.853058,327.638214 
	C201.046722,349.897491 185.101883,372.058502 169.316483,394.332550 
	C158.452621,409.661987 147.825378,425.159027 136.967194,440.492493 
	C122.891113,460.370117 108.456429,479.998871 94.675957,500.077820 
	C90.113533,506.725464 89.136551,516.045166 101.811974,518.345215 
	C103.575768,518.665222 105.375237,518.968750 107.158806,518.972290 
	C128.655334,519.015137 150.152359,519.072510 171.648315,518.953857 
	C177.745850,518.920227 183.930496,518.872437 189.917084,517.878662 
	C201.823853,515.902039 212.360825,510.316925 219.465118,500.693268 
	C235.765945,478.611694 251.203308,455.893585 267.041687,433.469543 
	C287.027893,405.172882 307.064331,376.911774 327.495758,348.032043 
M192.003036,605.975830 
	C193.721329,610.955688 197.234207,613.050232 202.469986,613.035339 
	C229.290512,612.958923 256.111603,612.937439 282.932068,613.023499 
	C298.914459,613.074829 311.529480,605.788574 320.553070,593.552490 
	C339.267273,568.176025 356.996887,542.074585 375.194672,516.315979 
	C397.806854,484.308899 420.483185,452.347168 443.131805,420.365845 
	C465.780396,388.384491 488.430176,356.403992 511.076965,324.421356 
	C519.158691,313.008087 527.279846,301.622223 535.285278,290.155609 
	C538.028015,286.226959 539.435852,281.827576 537.020569,277.261810 
	C534.661926,272.803009 530.395142,271.961487 525.704895,271.971527 
	C498.551086,272.029816 471.397095,271.989136 444.243195,272.024628 
	C442.455261,272.026978 440.628693,272.209564 438.886230,272.602020 
	C424.547729,275.831116 413.964935,283.884735 405.805389,296.242554 
	C394.161346,313.877777 381.572510,330.890381 369.342773,348.137421 
	C351.566833,373.205963 333.728302,398.230194 315.961517,423.305206 
	C305.431549,438.166565 295.058044,453.139069 284.490295,467.973328 
	C266.743591,492.884888 248.869537,517.705688 231.104416,542.604126 
	C219.868576,558.351624 208.685257,574.137207 197.583084,589.979065 
	C194.421417,594.490601 191.056854,599.050720 192.003036,605.975830 
M141.934097,362.569916 
	C147.853928,358.289551 155.149612,355.072357 159.433807,349.528107 
	C171.936203,333.348572 183.200790,316.214905 195.014526,299.500427 
	C217.618423,267.519653 240.251236,235.559372 262.901276,203.611282 
	C279.256439,180.542236 295.651611,157.501526 312.042877,134.458099 
	C322.782990,119.359261 333.619812,104.328606 344.275513,89.170570 
	C350.902069,79.744095 357.770630,70.430977 363.608521,60.523663 
	C368.909729,51.527142 363.931305,44.013027 353.481476,44.006123 
	C326.489288,43.988281 299.490509,43.645626 272.507660,44.148121 
	C258.799316,44.403408 246.583618,50.522861 238.604233,61.309956 
	C218.224350,88.860916 198.984924,117.254181 179.217026,145.259491 
	C158.225815,174.997803 137.163605,204.686035 116.110039,234.380295 
	C94.115173,265.402161 72.075783,296.392456 50.096764,327.425537 
	C44.747963,334.977753 39.218868,342.435547 34.403648,350.322021 
	C30.464655,356.773346 32.813248,363.483337 39.175400,365.571503 
	C41.917610,366.471588 44.928280,366.927551 47.819790,366.940125 
	C71.979004,367.045105 96.144791,367.296143 120.294846,366.814362 
	C127.302406,366.674561 134.265503,364.306335 141.934097,362.569916 
M691.069458,514.000183 
	C663.748840,514.000122 636.426453,513.814087 609.108337,514.074158 
	C594.263916,514.215515 582.144226,521.140076 573.349915,532.558594 
	C561.473755,547.978638 550.638733,564.202698 539.417114,580.124084 
	C517.255676,611.567078 495.174561,643.066772 472.985291,674.489990 
	C456.689026,697.567932 440.246399,720.542419 423.921936,743.600464 
	C415.294464,755.786560 406.944305,768.172668 398.134155,780.223755 
	C394.604614,785.051819 392.410248,789.961731 394.989716,795.541931 
	C397.512177,800.998840 402.952606,801.007568 408.116882,801.005249 
	C433.938354,800.993408 459.762482,801.222168 485.580261,800.913879 
	C500.334106,800.737732 512.634705,794.097717 521.482849,782.693054 
	C532.313660,768.732849 541.923706,753.828186 552.131714,739.381531 
	C573.117615,709.681824 594.144348,680.011047 615.164978,650.335938 
	C635.435364,621.719910 655.712402,593.108582 676.000610,564.505127 
	C683.422180,554.041748 690.985962,543.677612 698.290833,533.133667 
	C702.999084,526.337769 703.144836,515.361877 691.069458,514.000183 
M2367.540771,570.000427 
	C2364.768555,570.000427 2361.996338,570.000427 2358.850098,570.000427 
	C2358.850098,602.873474 2358.850098,635.200195 2358.850098,666.957825 
	C2353.977051,661.882202 2349.604980,655.921387 2343.941162,651.689026 
	C2325.926025,638.226868 2305.236084,633.651855 2283.255127,637.190125 
	C2264.177979,640.260925 2248.205322,649.419800 2235.676025,664.668274 
	C2219.892822,683.876587 2215.555176,706.269043 2218.336670,729.820007 
	C2220.672363,749.597656 2229.951660,766.797119 2245.500000,779.942200 
	C2258.326172,790.785950 2273.207764,797.150146 2289.992920,797.826294 
	C2298.270020,798.159729 2306.742920,797.341797 2314.912842,795.861633 
	C2332.027344,792.761047 2345.716553,783.502380 2356.892578,770.361755 
	C2357.612061,769.515808 2358.289062,768.633850 2358.985840,767.768677 
	C2359.351074,767.924805 2359.716064,768.080933 2360.081299,768.237061 
	C2360.081299,776.768921 2360.081299,785.300842 2360.081299,793.696228 
	C2368.679688,793.696228 2376.750977,793.696228 2384.724121,793.696228 
	C2384.724121,719.009216 2384.724121,644.626221 2384.724121,570.000427 
	C2379.144287,570.000427 2373.838135,570.000427 2367.540771,570.000427 
M1153.385742,339.000000 
	C1147.964844,339.000000 1142.543823,339.000000 1137.131958,339.000000 
	C1137.076294,340.065979 1136.901123,340.611694 1137.045776,341.052521 
	C1145.745117,367.557098 1154.477295,394.050934 1163.191650,420.550598 
	C1170.753784,443.546844 1178.267578,466.559082 1185.928955,489.522186 
	C1186.379761,490.873199 1187.895142,492.766022 1189.020630,492.841858 
	C1194.266602,493.195404 1199.549805,492.998535 1204.666626,492.998535 
	C1221.338745,453.076691 1237.820679,413.609985 1254.375977,373.967773 
	C1256.577393,378.944672 1258.739380,383.594055 1260.708984,388.323608 
	C1273.764648,419.674927 1287.164062,450.892578 1299.554077,482.505463 
	C1302.919800,491.093201 1307.113647,494.868713 1316.066772,493.021454 
	C1316.865967,492.856537 1317.750122,492.878235 1318.557983,493.021729 
	C1321.201050,493.491241 1322.288818,492.081390 1323.009521,489.800476 
	C1326.777832,477.872528 1330.554199,465.946259 1334.454468,454.060974 
	C1342.151245,430.606354 1350.054810,407.218842 1357.628418,383.724792 
	C1361.899780,370.474731 1365.691040,357.069794 1369.683228,343.730011 
	C1370.582031,340.726776 1369.883789,338.922913 1366.286377,338.974792 
	C1359.974854,339.065918 1353.661011,339.000214 1347.598633,339.000214 
	C1335.823975,378.250549 1324.154297,417.150909 1312.212158,456.959381 
	C1310.845825,454.510895 1309.764648,452.960846 1309.063232,451.254730 
	C1304.009277,438.962158 1299.015137,426.644836 1294.034546,414.322235 
	C1285.332764,392.793549 1276.568970,371.289337 1268.002686,349.706757 
	C1263.780396,339.068878 1263.953857,339.000000 1252.461304,339.000000 
	C1250.138550,339.000000 1247.815918,339.000000 1245.636719,339.000000 
	C1229.398682,378.490845 1213.255371,417.751343 1197.112061,457.011841 
	C1196.057617,455.668579 1196.210571,454.616852 1195.929810,453.697479 
	C1189.657959,433.155792 1183.321045,412.633911 1177.032959,392.097137 
	C1172.338257,376.763489 1167.192871,361.540253 1163.290161,346.006104 
	C1161.851196,340.279175 1159.899536,338.094574 1153.385742,339.000000 
M1477.046631,284.428375 
	C1473.687622,288.059753 1470.005981,291.446503 1467.031860,295.369598 
	C1459.048950,305.899475 1456.334351,317.982666 1456.946655,331.075165 
	C1457.537476,343.708557 1461.667603,354.844574 1470.486450,363.886444 
	C1479.461670,373.088440 1490.677368,378.943756 1502.736450,382.927612 
	C1516.889282,387.603180 1531.318848,391.438324 1545.492554,396.054718 
	C1568.293213,403.481049 1578.217285,418.188416 1575.853271,441.859802 
	C1574.845825,451.948242 1569.234009,460.178162 1560.890991,465.941498 
	C1545.499878,476.573792 1528.370972,478.411224 1510.676880,473.732086 
	C1500.935059,471.155853 1492.419067,466.140167 1485.993408,457.698883 
	C1480.101074,449.958160 1476.974487,441.225372 1474.694092,432.312256 
	C1466.251099,432.312256 1458.190674,432.312256 1450.110107,432.312256 
	C1450.784180,435.441437 1451.327148,438.281128 1452.010986,441.086395 
	C1457.266968,462.643951 1469.020020,479.061615 1489.281006,489.084503 
	C1502.995850,495.869202 1517.460327,497.580475 1532.469727,497.030426 
	C1547.134399,496.493073 1560.873291,492.796326 1573.259033,484.931335 
	C1597.207153,469.724182 1605.430420,445.502258 1600.815918,420.058472 
	C1596.593140,396.773834 1580.230957,383.689117 1559.184937,376.117584 
	C1542.608276,370.153992 1525.477661,365.739838 1508.851318,359.901947 
	C1491.770752,353.904572 1480.560669,344.101837 1482.001343,323.788544 
	C1482.898438,311.141846 1490.827881,300.189819 1502.848511,294.879181 
	C1512.058960,290.810059 1521.597168,290.476868 1531.204834,291.117615 
	C1540.260254,291.721558 1548.198975,295.568512 1555.128174,301.567230 
	C1563.798462,309.073181 1567.267578,319.140900 1569.321045,329.722687 
	C1577.399780,329.722687 1585.161621,329.722687 1593.291626,329.722687 
	C1592.807129,327.650635 1592.266113,325.948792 1592.023438,324.205353 
	C1588.707397,300.384766 1576.019165,283.628998 1553.833984,274.456024 
	C1540.130859,268.790192 1525.615234,267.794861 1511.121216,270.156342 
	C1499.007446,272.130005 1487.476318,276.216278 1477.046631,284.428375 
M1208.871826,573.027222 
	C1196.640991,577.086365 1185.156128,582.156311 1176.223267,592.134644 
	C1162.956055,606.954651 1159.396973,624.111450 1163.535400,642.912903 
	C1167.198364,659.554810 1178.256348,671.011353 1193.292236,677.802124 
	C1205.934692,683.511841 1219.352905,687.563904 1232.565186,691.934021 
	C1243.953857,695.700989 1255.788330,698.043518 1265.877686,705.260620 
	C1278.410034,714.225159 1283.711914,726.517395 1281.797363,741.259399 
	C1279.825439,756.443481 1270.877319,767.088379 1256.579102,773.000244 
	C1246.837036,777.028381 1236.745483,777.909729 1226.295410,777.070435 
	C1214.781860,776.145874 1204.628418,772.247925 1196.066284,764.529602 
	C1187.837402,757.111694 1183.683716,747.396118 1180.901978,736.906799 
	C1180.509766,735.427979 1178.866455,733.231262 1177.714233,733.175232 
	C1170.603394,732.829102 1163.467163,733.001465 1155.652954,733.001465 
	C1156.150391,736.313538 1156.349609,739.197815 1157.035400,741.961304 
	C1162.497559,763.971375 1174.257568,781.226624 1195.300293,790.967896 
	C1210.500854,798.004700 1226.433716,800.197083 1243.229858,798.134827 
	C1264.391724,795.536560 1283.003784,788.184937 1295.726074,770.531738 
	C1309.140503,751.918396 1310.802734,731.144592 1302.387207,710.050110 
	C1295.324829,692.346985 1280.272339,683.042969 1263.147949,677.099609 
	C1249.079712,672.216919 1234.625488,668.457397 1220.422363,663.948181 
	C1211.067749,660.978149 1201.842651,657.367737 1195.058960,649.908264 
	C1187.004272,641.051270 1185.314819,630.504700 1188.398560,619.089600 
	C1190.383667,611.741516 1193.926270,605.540771 1200.380371,601.014282 
	C1207.316040,596.150024 1214.838013,594.009460 1223.205200,592.686584 
	C1233.913574,590.993469 1243.829224,592.806335 1252.807861,597.604980 
	C1265.697998,604.493958 1272.510864,616.242798 1274.346436,630.767822 
	C1282.243896,630.767822 1290.010498,630.767822 1298.373291,630.767822 
	C1297.875488,628.084961 1297.413452,625.738770 1297.007080,623.382935 
	C1291.351196,590.603760 1266.150146,572.434753 1235.687256,571.157471 
	C1227.076782,570.796387 1218.386841,572.334839 1208.871826,573.027222 
M1100.529419,492.999512 
	C1105.291748,492.999512 1110.053955,492.999512 1114.710083,492.999512 
	C1114.710083,441.339050 1114.710083,390.276367 1114.710083,339.292297 
	C1106.345459,339.292297 1098.273682,339.292297 1089.620728,339.292297 
	C1089.620728,348.046051 1089.620728,356.517029 1089.620728,362.608490 
	C1085.459717,359.172668 1080.489624,354.761688 1075.208252,350.761597 
	C1053.883545,334.610321 1030.033325,331.385040 1004.636108,337.872070 
	C988.771118,341.924347 976.021667,350.851288 965.657837,363.672791 
	C955.119263,376.710419 949.732544,391.677429 948.140198,407.939270 
	C946.369751,426.020599 950.018494,443.311157 959.535034,458.952240 
	C968.474182,473.644196 980.653809,484.867493 996.987793,490.993439 
	C1009.260742,495.596313 1021.794128,497.716156 1035.073853,496.159851 
	C1045.982056,494.881500 1056.123169,492.043457 1065.748169,486.814331 
	C1075.877930,481.310913 1083.913574,473.566803 1091.250122,463.466614 
	C1091.250122,473.987701 1091.250122,483.403198 1091.250122,492.999512 
	C1094.245850,492.999512 1096.893311,492.999512 1100.529419,492.999512 
M1884.067749,650.412354 
	C1872.573120,659.587097 1863.431274,670.480347 1857.901611,684.352356 
	C1851.027710,701.597168 1849.156006,719.072266 1853.594360,737.212402 
	C1857.658081,753.820312 1865.812622,767.802917 1878.622192,779.251038 
	C1886.863403,786.616394 1896.276978,791.733215 1906.652466,794.889404 
	C1918.513672,798.497559 1930.690430,798.975464 1943.044312,797.068115 
	C1962.275879,794.098938 1978.276367,785.754578 1990.331665,770.254395 
	C1991.114380,769.247864 1992.329590,768.577820 1994.170166,767.077393 
	C1994.170166,776.824768 1994.170166,785.264771 1994.170166,793.753113 
	C2002.228027,793.753113 2009.965576,793.753113 2017.758179,793.753113 
	C2017.758179,742.440735 2017.758179,691.375549 2017.758179,640.245361 
	C2009.776611,640.245361 2002.039185,640.245361 1993.729980,640.245361 
	C1993.729980,649.297485 1993.729980,658.117371 1993.729980,668.363220 
	C1990.442627,664.201111 1988.420898,660.843384 1985.661987,658.278198 
	C1968.007202,641.862366 1947.340088,634.738586 1923.036377,636.783203 
	C1908.880981,637.974121 1896.557251,642.944092 1884.067749,650.412354 
M2181.561523,360.039795 
	C2174.795898,354.701355 2168.606201,348.307739 2161.148438,344.238525 
	C2144.361084,335.078888 2126.069580,333.207397 2107.196777,335.966278 
	C2084.501953,339.283875 2066.604248,350.250397 2054.019531,369.385010 
	C2041.641846,388.204834 2038.177124,408.754150 2041.816040,431.052643 
	C2045.522461,453.764954 2056.616943,471.421661 2075.569092,483.885315 
	C2093.857666,495.912720 2114.565186,498.843353 2135.778809,495.792847 
	C2156.511719,492.811432 2174.123779,483.016693 2187.625977,466.732727 
	C2191.424316,462.152130 2194.232910,456.751312 2197.967529,451.000000 
	C2192.134033,451.000000 2187.587158,451.444000 2183.162842,450.897430 
	C2176.281982,450.047363 2172.088867,452.600525 2167.235107,457.809357 
	C2151.349121,474.857941 2130.896484,479.836365 2108.416992,475.612915 
	C2093.617920,472.832489 2081.960449,464.619293 2074.074707,451.543060 
	C2069.396240,443.784973 2066.530029,435.446869 2065.865234,425.900391 
	C2110.887451,425.900391 2155.287354,425.900391 2200.805420,425.900391 
	C2199.921143,415.171783 2199.603027,404.818237 2198.094482,394.641205 
	C2196.192871,381.813721 2189.991211,370.712158 2181.561523,360.039795 
M1632.961426,371.451935 
	C1624.425293,384.153503 1620.631470,398.366119 1620.057861,413.461151 
	C1619.621704,424.936920 1621.589722,436.118378 1626.034790,446.745178 
	C1633.857178,465.445465 1646.598633,479.918549 1665.060791,488.348694 
	C1679.605713,494.990204 1694.980469,497.939331 1711.364380,496.228119 
	C1724.633179,494.842163 1737.087158,491.801544 1748.404663,484.885193 
	C1771.971680,470.482727 1784.560791,448.923370 1786.818604,421.790009 
	C1788.481323,401.807953 1783.133545,383.288422 1771.025513,366.923950 
	C1762.083862,354.838959 1750.537842,346.514557 1736.648315,340.870209 
	C1720.344604,334.244751 1703.513428,333.424225 1686.600464,336.206329 
	C1674.555908,338.187622 1663.297119,342.811493 1653.088013,350.144745 
	C1645.075439,355.900146 1638.973877,363.138245 1632.961426,371.451935 
M974.585449,727.930420 
	C974.055542,717.810669 974.905640,707.381592 972.720276,697.632935 
	C967.515808,674.416016 953.821899,657.031738 932.543457,645.950378 
	C914.160217,636.376770 894.741028,634.115662 874.509155,638.000549 
	C848.426697,643.008911 828.710388,656.805115 816.776611,680.762573 
	C808.595093,697.187317 806.564026,714.497681 809.892395,732.680786 
	C813.454651,752.142212 822.854797,768.170227 838.021301,780.279114 
	C860.660400,798.354065 887.033936,801.819946 914.511719,795.558533 
	C932.444763,791.472107 947.730896,781.917419 958.752563,766.680847 
	C966.971924,755.318115 973.129883,743.024292 974.585449,727.930420 
M2093.551270,645.967712 
	C2086.190430,650.517273 2080.195312,656.429626 2075.154785,663.876953 
	C2075.154785,656.044250 2075.154785,648.211548 2075.154785,640.201782 
	C2066.530029,640.201782 2058.461182,640.201782 2050.356934,640.201782 
	C2050.356934,691.575928 2050.356934,742.747986 2050.356934,793.642700 
	C2059.123047,793.642700 2067.530273,793.642700 2075.999756,793.642700 
	C2075.999756,763.969299 2075.755615,734.650330 2076.098633,705.338196 
	C2076.281494,689.702087 2083.771240,677.233521 2096.102295,668.103210 
	C2107.590820,659.596741 2120.898193,657.021851 2134.865967,660.112671 
	C2146.434814,662.672668 2155.378174,669.078247 2161.061523,679.899902 
	C2166.025879,689.352417 2167.778076,699.497070 2167.904053,709.862122 
	C2168.202148,734.346680 2168.000000,758.837280 2168.000000,783.325439 
	C2168.000000,786.775208 2168.000000,790.224976 2168.000000,793.774292 
	C2176.521484,793.774292 2184.590820,793.774292 2193.000000,793.774292 
	C2193.000000,791.925354 2193.000000,790.297180 2193.000000,788.669006 
	C2193.000000,761.682068 2193.232178,734.691895 2192.862305,707.710022 
	C2192.747314,699.304871 2191.850830,690.714294 2189.853027,682.566284 
	C2182.666016,653.253418 2160.766113,636.783997 2132.281982,636.163635 
	C2118.953369,635.873413 2105.896729,638.587219 2093.551270,645.967712 
M2426.965088,457.358826 
	C2443.731934,418.074432 2460.498779,378.790009 2477.417480,339.150391 
	C2467.976074,339.150391 2459.172119,339.150391 2450.250244,339.150391 
	C2434.175293,378.941589 2418.105957,418.718689 2402.036865,458.495789 
	C2401.541504,458.325439 2401.045898,458.155090 2400.550537,457.984741 
	C2384.167725,418.395874 2367.784912,378.807037 2351.538818,339.548157 
	C2342.766846,339.548157 2334.083496,339.548157 2324.971924,339.548157 
	C2336.189453,365.928436 2347.068604,391.714264 2358.114502,417.428467 
	C2367.600830,439.512146 2377.314209,461.498260 2386.790771,483.586151 
	C2387.446045,485.113800 2387.539795,487.366028 2386.919189,488.881958 
	C2381.398682,502.366821 2375.666260,515.764893 2369.979492,529.181580 
	C2366.368408,537.701843 2362.729248,546.210327 2359.027588,554.900146 
	C2368.175049,554.900146 2376.824707,554.900146 2385.336670,554.900146 
	C2392.192627,538.720642 2398.980713,522.670044 2405.794189,506.630341 
	C2412.682617,490.414459 2419.596924,474.209503 2426.965088,457.358826 
M1917.312500,467.972168 
	C1906.862793,473.529419 1895.748413,475.502075 1883.929565,475.098083 
	C1870.573486,474.641571 1858.637817,470.426086 1849.099121,461.396667 
	C1830.747681,444.024658 1825.699585,422.117065 1832.219849,398.358154 
	C1841.162720,365.771362 1868.951904,351.584015 1899.795898,357.186218 
	C1916.993042,360.309692 1929.725464,370.640930 1938.512939,385.833435 
	C1939.360718,387.299316 1941.557007,388.782013 1943.192139,388.857910 
	C1950.300903,389.187836 1957.433960,388.999481 1964.625366,388.999481 
	C1954.340454,354.209808 1919.055420,328.191345 1869.884033,336.219025 
	C1836.878296,341.607513 1800.937134,368.991180 1805.124390,424.679962 
	C1807.486084,456.091400 1829.773438,493.590271 1883.599854,496.749695 
	C1902.254517,497.844635 1920.177612,493.187531 1935.913452,482.044373 
	C1949.800171,472.210693 1959.125366,459.153625 1964.801025,443.000031 
	C1957.226196,443.000031 1949.908203,443.120789 1942.598022,442.933746 
	C1940.078491,442.869293 1938.984253,443.772400 1937.945068,445.990265 
	C1933.595459,455.273560 1926.421997,462.041992 1917.312500,467.972168 
M1446.941284,789.576294 
	C1470.237549,777.493774 1485.287598,753.373352 1484.427490,744.000549 
	C1477.628296,744.000549 1470.803345,743.865295 1463.992188,744.111511 
	C1462.584595,744.162415 1460.703491,745.297607 1459.933838,746.503235 
	C1455.020874,754.199829 1450.078735,761.932434 1442.214233,766.920532 
	C1429.212280,775.167175 1415.182251,778.608948 1399.629517,776.128052 
	C1385.126221,773.814453 1372.853149,768.184326 1363.772583,756.304443 
	C1350.568848,739.030090 1347.109863,719.662170 1353.170776,699.181519 
	C1362.052368,669.169434 1385.630493,654.761047 1416.095825,658.214966 
	C1436.230713,660.497559 1451.537964,671.244202 1460.399780,689.702087 
	C1468.729370,689.702087 1476.802124,689.702087 1484.902832,689.702087 
	C1483.822266,681.386963 1475.933594,669.159607 1470.431519,663.024414 
	C1454.217407,644.945007 1433.247437,636.924133 1409.493042,636.199341 
	C1401.297485,635.949341 1392.822144,637.163208 1384.837402,639.159485 
	C1361.654053,644.955566 1343.972900,658.513794 1333.568848,680.125183 
	C1324.582153,698.791870 1322.931641,718.688538 1328.039185,738.853333 
	C1336.860229,773.679688 1365.227905,795.055664 1399.100952,797.932068 
	C1415.416504,799.317627 1431.250000,796.798401 1446.941284,789.576294 
M1011.000000,767.500000 
	C1011.000000,776.263184 1011.000000,785.026428 1011.000000,793.712158 
	C1019.646118,793.712158 1027.717529,793.712158 1036.166992,793.712158 
	C1036.166992,749.362732 1036.166992,705.299927 1036.166992,660.844727 
	C1051.621460,660.844727 1066.694336,660.844727 1081.722168,660.844727 
	C1081.722168,653.708069 1081.722168,646.970032 1081.722168,640.000427 
	C1073.973511,640.000427 1066.500244,640.000427 1059.026855,640.000427 
	C1051.426880,640.000427 1043.826904,640.000427 1035.999756,640.000427 
	C1035.999756,635.141907 1035.869385,630.829468 1036.036621,626.528564 
	C1036.201782,622.277954 1036.346069,617.983765 1037.064087,613.805664 
	C1038.933228,602.929382 1045.659424,593.797119 1057.420166,593.097412 
	C1066.111206,592.580261 1074.858032,592.995850 1083.998047,592.995850 
	C1083.998047,587.571411 1084.135620,581.260010 1083.860596,574.966553 
	C1083.815674,573.937012 1082.095581,572.375549 1080.906738,572.096924 
	C1071.602661,569.916016 1062.253662,569.645203 1052.700684,570.879700 
	C1042.335693,572.219055 1032.875366,575.230652 1025.133545,582.409790 
	C1014.947388,591.855469 1012.057190,604.424805 1011.097717,617.525269 
	C1010.556519,624.915283 1011.000244,632.377441 1011.000244,640.189941 
	C1001.010254,640.189941 991.600403,640.189941 982.295837,640.189941 
	C982.295837,647.330505 982.295837,654.070007 982.295837,661.196106 
	C991.996277,661.196106 1001.406250,661.196106 1011.000000,661.196106 
	C1011.000000,696.562378 1011.000000,731.531189 1011.000000,767.500000 
M1675.000366,646.572754 
	C1675.000366,651.331421 1675.000366,656.090149 1675.000366,661.236694 
	C1686.037476,661.236694 1696.448730,661.236694 1707.000000,661.236694 
	C1707.000000,688.456238 1706.752075,715.278381 1707.137695,742.091492 
	C1707.268311,751.170105 1708.062622,760.456116 1710.218994,769.238403 
	C1713.561035,782.848450 1721.496582,792.639771 1736.202881,796.178101 
	C1750.008301,799.499695 1763.322632,797.959045 1776.811035,794.798401 
	C1776.811035,787.816040 1776.811035,781.030212 1776.811035,774.858032 
	C1768.518555,775.244019 1760.392578,775.931335 1752.268188,775.911316 
	C1744.540283,775.892334 1738.353516,772.370117 1735.587280,764.933838 
	C1733.760010,760.021606 1732.216797,754.666260 1732.155884,749.490417 
	C1731.826782,721.495544 1731.996582,693.494812 1732.009766,665.496094 
	C1732.010498,664.060608 1732.153931,662.625244 1732.251099,660.812073 
	C1747.986084,660.812073 1763.395142,660.812073 1778.700562,660.812073 
	C1778.700562,653.667114 1778.700562,646.926270 1778.700562,639.795898 
	C1762.995728,639.795898 1747.586670,639.795898 1731.787354,639.795898 
	C1731.787354,623.322205 1731.787354,607.246643 1731.787354,591.311157 
	C1723.309814,591.311157 1715.235962,591.311157 1706.771973,591.311157 
	C1706.771973,607.694641 1706.771973,623.770203 1706.771973,640.237305 
	C1695.964600,640.237305 1685.553955,640.237305 1675.000366,640.237305 
	C1675.000366,642.291199 1675.000366,643.944031 1675.000366,646.572754 
M2242.000000,413.500000 
	C2242.571289,430.158051 2240.496094,446.916595 2243.990479,463.464691 
	C2247.145020,478.401215 2254.174805,490.131836 2269.922607,494.368439 
	C2273.804443,495.412689 2278.031006,495.143250 2281.947021,496.099396 
	C2291.574463,498.449951 2300.596191,495.139160 2309.792236,493.512756 
	C2310.653809,493.360382 2311.873291,491.833130 2311.900635,490.913605 
	C2312.087158,484.662292 2311.998291,478.402802 2311.998291,472.109192 
	C2307.543945,473.045593 2303.656982,474.262939 2299.693115,474.616699 
	C2290.002441,475.481598 2280.361816,475.892029 2272.980713,467.523438 
	C2268.108887,462.000061 2267.163818,455.226624 2267.104492,448.495117 
	C2266.856201,420.338837 2266.996826,392.179108 2267.009521,364.020630 
	C2267.010010,362.749512 2267.153809,361.478455 2267.253174,359.834167 
	C2282.631348,359.834167 2297.704590,359.834167 2312.716309,359.834167 
	C2312.716309,352.695587 2312.716309,345.956848 2312.716309,338.829956 
	C2297.363525,338.829956 2282.290283,338.829956 2266.830566,338.829956 
	C2266.830566,322.364319 2266.830566,306.291748 2266.830566,290.284790 
	C2258.359619,290.284790 2250.287842,290.284790 2241.827637,290.284790 
	C2241.827637,306.638611 2241.827637,322.711182 2241.827637,339.173248 
	C2231.027344,339.173248 2220.618408,339.173248 2210.289062,339.173248 
	C2210.289062,346.313904 2210.289062,353.052917 2210.289062,360.180969 
	C2220.982422,360.180969 2231.391602,360.180969 2242.000000,360.180969 
	C2242.000000,377.885925 2242.000000,395.192963 2242.000000,413.500000 
M1803.000000,661.500000 
	C1803.000000,705.592224 1803.000000,749.684509 1803.000000,793.712158 
	C1811.643311,793.712158 1819.716064,793.712158 1827.715576,793.712158 
	C1827.715576,719.024658 1827.715576,644.625244 1827.715576,570.288330 
	C1819.355713,570.288330 1811.283203,570.288330 1803.000000,570.288330 
	C1803.000000,600.550476 1803.000000,630.525269 1803.000000,661.500000 
M2015.000000,378.500000 
	C2015.000000,365.403748 2015.000000,352.307495 2015.000000,339.290100 
	C2006.350342,339.290100 1998.277710,339.290100 1990.286987,339.290100 
	C1990.286987,390.647491 1990.286987,441.714264 1990.286987,492.709290 
	C1998.649780,492.709290 2006.722412,492.709290 2015.000000,492.709290 
	C2015.000000,454.779663 2015.000000,417.139832 2015.000000,378.500000 
M2014.499023,316.000366 
	C2015.015503,315.189880 2015.443848,314.304077 2016.062256,313.580750 
	C2020.771240,308.072205 2019.593262,299.573578 2016.372681,294.984161 
	C2011.842773,288.529144 2004.795532,286.981079 1999.156494,288.416626 
	C1990.781494,290.548767 1986.527954,295.364319 1986.066772,303.092834 
	C1985.660400,309.901917 1988.209473,315.941711 1994.576172,318.651398 
	C2001.035034,321.400421 2007.950928,321.387054 2014.499023,316.000366 
z"
    />
    <path
      fill="#ED725A"
      opacity="1.000000"
      stroke="none"
      d="
M607.717651,424.678101 
	C591.627747,447.463776 575.773865,469.966156 559.871216,492.434052 
	C535.492065,526.877930 511.078369,561.297424 486.681427,595.728699 
	C469.728363,619.654480 452.777496,643.581848 435.828003,667.510193 
	C413.132355,699.550537 390.443604,731.595764 367.740967,763.631165 
	C362.747009,770.678040 358.154297,778.073242 352.574158,784.624329 
	C345.736847,792.651245 336.488586,797.314636 326.324890,799.924927 
	C323.349182,800.689148 320.171478,800.946106 317.084930,800.955444 
	C291.259369,801.033752 265.432983,801.074707 239.608353,800.902283 
	C236.493515,800.881470 232.878494,800.288513 230.382355,798.627563 
	C224.993423,795.041870 224.412079,789.001343 228.542572,783.038696 
	C239.487839,767.238525 250.587402,751.544861 261.681244,735.848145 
	C270.709351,723.074158 279.824493,710.361755 288.889343,697.613708 
	C306.923523,672.252014 324.969574,646.898743 342.974304,621.516174 
	C367.292755,587.232788 391.575745,552.924194 415.876068,518.627869 
	C438.575562,486.590912 461.278992,454.556732 483.978516,422.519775 
	C508.278809,388.223480 532.516235,353.882446 556.908691,319.651917 
	C565.236694,307.964966 573.197449,295.879364 582.723816,285.225830 
	C590.595276,276.423035 601.515198,271.947296 613.828735,271.978821 
	C640.654053,272.047455 667.479614,271.992218 694.305115,272.004150 
	C703.990356,272.008453 708.734802,278.735992 704.109070,287.183746 
	C699.518982,295.566437 693.745483,303.321472 688.250916,311.184021 
	C679.291016,324.005280 670.119385,336.678406 661.066711,349.435089 
	C643.344299,374.408844 625.642334,399.397095 607.717651,424.678101 
z"
    />
    <path
      fill="#00BD94"
      opacity="1.000000"
      stroke="none"
      d="
M327.287415,348.333679 
	C307.064331,376.911774 287.027893,405.172882 267.041687,433.469543 
	C251.203308,455.893585 235.765945,478.611694 219.465118,500.693268 
	C212.360825,510.316925 201.823853,515.902039 189.917084,517.878662 
	C183.930496,518.872437 177.745850,518.920227 171.648315,518.953857 
	C150.152359,519.072510 128.655334,519.015137 107.158806,518.972290 
	C105.375237,518.968750 103.575768,518.665222 101.811974,518.345215 
	C89.136551,516.045166 90.113533,506.725464 94.675957,500.077820 
	C108.456429,479.998871 122.891113,460.370117 136.967194,440.492493 
	C147.825378,425.159027 158.452621,409.661987 169.316483,394.332550 
	C185.101883,372.058502 201.046722,349.897491 216.853058,327.638214 
	C239.563995,295.655548 262.183624,263.608063 284.893738,231.624802 
	C308.741730,198.039032 332.710022,164.538528 356.510681,130.919312 
	C371.141968,110.252129 385.803925,89.598518 399.969666,68.613205 
	C407.462555,57.513222 417.102722,49.760666 429.752991,45.763157 
	C432.981323,44.742996 436.473450,44.092030 439.848389,44.075123 
	C466.676819,43.940746 493.506989,43.908054 520.334290,44.128162 
	C523.362915,44.153008 526.962280,45.206078 529.280823,47.055984 
	C534.769531,51.435154 533.983948,57.295113 528.181763,65.351021 
	C515.763550,82.593147 503.519165,99.960571 491.208466,117.280113 
	C474.826019,140.328049 458.454956,163.384064 442.066742,186.427887 
	C418.193787,219.996185 394.278809,253.534668 370.442230,287.128754 
	C356.067474,307.387817 341.807373,327.728210 327.287415,348.333679 
z"
    />
    <path
      fill="#3399FF"
      opacity="1.000000"
      stroke="none"
      d="
M192.001770,605.553406 
	C191.056854,599.050720 194.421417,594.490601 197.583084,589.979065 
	C208.685257,574.137207 219.868576,558.351624 231.104416,542.604126 
	C248.869537,517.705688 266.743591,492.884888 284.490295,467.973328 
	C295.058044,453.139069 305.431549,438.166565 315.961517,423.305206 
	C333.728302,398.230194 351.566833,373.205963 369.342773,348.137421 
	C381.572510,330.890381 394.161346,313.877777 405.805389,296.242554 
	C413.964935,283.884735 424.547729,275.831116 438.886230,272.602020 
	C440.628693,272.209564 442.455261,272.026978 444.243195,272.024628 
	C471.397095,271.989136 498.551086,272.029816 525.704895,271.971527 
	C530.395142,271.961487 534.661926,272.803009 537.020569,277.261810 
	C539.435852,281.827576 538.028015,286.226959 535.285278,290.155609 
	C527.279846,301.622223 519.158691,313.008087 511.076965,324.421356 
	C488.430176,356.403992 465.780396,388.384491 443.131805,420.365845 
	C420.483185,452.347168 397.806854,484.308899 375.194672,516.315979 
	C356.996887,542.074585 339.267273,568.176025 320.553070,593.552490 
	C311.529480,605.788574 298.914459,613.074829 282.932068,613.023499 
	C256.111603,612.937439 229.290512,612.958923 202.469986,613.035339 
	C197.234207,613.050232 193.721329,610.955688 192.001770,605.553406 
z"
    />
    <path
      fill="#9966FF"
      opacity="1.000000"
      stroke="none"
      d="
M141.591553,362.764771 
	C134.265503,364.306335 127.302406,366.674561 120.294846,366.814362 
	C96.144791,367.296143 71.979004,367.045105 47.819790,366.940125 
	C44.928280,366.927551 41.917610,366.471588 39.175400,365.571503 
	C32.813248,363.483337 30.464655,356.773346 34.403648,350.322021 
	C39.218868,342.435547 44.747963,334.977753 50.096764,327.425537 
	C72.075783,296.392456 94.115173,265.402161 116.110039,234.380295 
	C137.163605,204.686035 158.225815,174.997803 179.217026,145.259491 
	C198.984924,117.254181 218.224350,88.860916 238.604233,61.309956 
	C246.583618,50.522861 258.799316,44.403408 272.507660,44.148121 
	C299.490509,43.645626 326.489288,43.988281 353.481476,44.006123 
	C363.931305,44.013027 368.909729,51.527142 363.608521,60.523663 
	C357.770630,70.430977 350.902069,79.744095 344.275513,89.170570 
	C333.619812,104.328606 322.782990,119.359261 312.042877,134.458099 
	C295.651611,157.501526 279.256439,180.542236 262.901276,203.611282 
	C240.251236,235.559372 217.618423,267.519653 195.014526,299.500427 
	C183.200790,316.214905 171.936203,333.348572 159.433807,349.528107 
	C155.149612,355.072357 147.853928,358.289551 141.591553,362.764771 
z"
    />
    <path
      fill="#FFCC05"
      opacity="1.000000"
      stroke="none"
      d="
M691.517578,514.001343 
	C703.144836,515.361877 702.999084,526.337769 698.290833,533.133667 
	C690.985962,543.677612 683.422180,554.041748 676.000610,564.505127 
	C655.712402,593.108582 635.435364,621.719910 615.164978,650.335938 
	C594.144348,680.011047 573.117615,709.681824 552.131714,739.381531 
	C541.923706,753.828186 532.313660,768.732849 521.482849,782.693054 
	C512.634705,794.097717 500.334106,800.737732 485.580261,800.913879 
	C459.762482,801.222168 433.938354,800.993408 408.116882,801.005249 
	C402.952606,801.007568 397.512177,800.998840 394.989716,795.541931 
	C392.410248,789.961731 394.604614,785.051819 398.134155,780.223755 
	C406.944305,768.172668 415.294464,755.786560 423.921936,743.600464 
	C440.246399,720.542419 456.689026,697.567932 472.985291,674.489990 
	C495.174561,643.066772 517.255676,611.567078 539.417114,580.124084 
	C550.638733,564.202698 561.473755,547.978638 573.349915,532.558594 
	C582.144226,521.140076 594.263916,514.215515 609.108337,514.074158 
	C636.426453,513.814087 663.748840,514.000122 691.517578,514.001343 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M2368.036377,570.000427 
	C2373.838135,570.000427 2379.144287,570.000427 2384.724121,570.000427 
	C2384.724121,644.626221 2384.724121,719.009216 2384.724121,793.696228 
	C2376.750977,793.696228 2368.679688,793.696228 2360.081299,793.696228 
	C2360.081299,785.300842 2360.081299,776.768921 2360.081299,768.237061 
	C2359.716064,768.080933 2359.351074,767.924805 2358.985840,767.768677 
	C2358.289062,768.633850 2357.612061,769.515808 2356.892578,770.361755 
	C2345.716553,783.502380 2332.027344,792.761047 2314.912842,795.861633 
	C2306.742920,797.341797 2298.270020,798.159729 2289.992920,797.826294 
	C2273.207764,797.150146 2258.326172,790.785950 2245.500000,779.942200 
	C2229.951660,766.797119 2220.672363,749.597656 2218.336670,729.820007 
	C2215.555176,706.269043 2219.892822,683.876587 2235.676025,664.668274 
	C2248.205322,649.419800 2264.177979,640.260925 2283.255127,637.190125 
	C2305.236084,633.651855 2325.926025,638.226868 2343.941162,651.689026 
	C2349.604980,655.921387 2353.977051,661.882202 2358.850098,666.957825 
	C2358.850098,635.200195 2358.850098,602.873474 2358.850098,570.000427 
	C2361.996338,570.000427 2364.768555,570.000427 2368.036377,570.000427 
M2356.553223,735.958008 
	C2359.990723,725.413086 2359.926270,714.625854 2357.911133,703.939636 
	C2355.156494,689.332092 2347.579590,677.552734 2335.417725,668.834167 
	C2322.829834,659.810303 2309.010010,655.988586 2293.464111,657.930298 
	C2274.471680,660.302490 2260.266846,669.446106 2250.971680,686.215027 
	C2243.603027,699.508667 2241.395508,713.576050 2243.957764,728.557434 
	C2246.590088,743.949768 2253.686035,756.611389 2266.213623,765.992676 
	C2281.443115,777.397522 2298.583008,779.837830 2316.530029,774.870117 
	C2336.407959,769.367798 2350.089111,756.820129 2356.553223,735.958008 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1153.866821,339.000000 
	C1159.899536,338.094574 1161.851196,340.279175 1163.290161,346.006104 
	C1167.192871,361.540253 1172.338257,376.763489 1177.032959,392.097137 
	C1183.321045,412.633911 1189.657959,433.155792 1195.929810,453.697479 
	C1196.210571,454.616852 1196.057617,455.668579 1197.112061,457.011841 
	C1213.255371,417.751343 1229.398682,378.490845 1245.636719,339.000000 
	C1247.815918,339.000000 1250.138550,339.000000 1252.461304,339.000000 
	C1263.953857,339.000000 1263.780396,339.068878 1268.002686,349.706757 
	C1276.568970,371.289337 1285.332764,392.793549 1294.034546,414.322235 
	C1299.015137,426.644836 1304.009277,438.962158 1309.063232,451.254730 
	C1309.764648,452.960846 1310.845825,454.510895 1312.212158,456.959381 
	C1324.154297,417.150909 1335.823975,378.250549 1347.598633,339.000214 
	C1353.661011,339.000214 1359.974854,339.065918 1366.286377,338.974792 
	C1369.883789,338.922913 1370.582031,340.726776 1369.683228,343.730011 
	C1365.691040,357.069794 1361.899780,370.474731 1357.628418,383.724792 
	C1350.054810,407.218842 1342.151245,430.606354 1334.454468,454.060974 
	C1330.554199,465.946259 1326.777832,477.872528 1323.009521,489.800476 
	C1322.288818,492.081390 1321.201050,493.491241 1318.557983,493.021729 
	C1317.750122,492.878235 1316.865967,492.856537 1316.066772,493.021454 
	C1307.113647,494.868713 1302.919800,491.093201 1299.554077,482.505463 
	C1287.164062,450.892578 1273.764648,419.674927 1260.708984,388.323608 
	C1258.739380,383.594055 1256.577393,378.944672 1254.375977,373.967773 
	C1237.820679,413.609985 1221.338745,453.076691 1204.666626,492.998535 
	C1199.549805,492.998535 1194.266602,493.195404 1189.020630,492.841858 
	C1187.895142,492.766022 1186.379761,490.873199 1185.928955,489.522186 
	C1178.267578,466.559082 1170.753784,443.546844 1163.191650,420.550598 
	C1154.477295,394.050934 1145.745117,367.557098 1137.045776,341.052521 
	C1136.901123,340.611694 1137.076294,340.065979 1137.131958,339.000000 
	C1142.543823,339.000000 1147.964844,339.000000 1153.866821,339.000000 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1477.317383,284.185974 
	C1487.476318,276.216278 1499.007446,272.130005 1511.121216,270.156342 
	C1525.615234,267.794861 1540.130859,268.790192 1553.833984,274.456024 
	C1576.019165,283.628998 1588.707397,300.384766 1592.023438,324.205353 
	C1592.266113,325.948792 1592.807129,327.650635 1593.291626,329.722687 
	C1585.161621,329.722687 1577.399780,329.722687 1569.321045,329.722687 
	C1567.267578,319.140900 1563.798462,309.073181 1555.128174,301.567230 
	C1548.198975,295.568512 1540.260254,291.721558 1531.204834,291.117615 
	C1521.597168,290.476868 1512.058960,290.810059 1502.848511,294.879181 
	C1490.827881,300.189819 1482.898438,311.141846 1482.001343,323.788544 
	C1480.560669,344.101837 1491.770752,353.904572 1508.851318,359.901947 
	C1525.477661,365.739838 1542.608276,370.153992 1559.184937,376.117584 
	C1580.230957,383.689117 1596.593140,396.773834 1600.815918,420.058472 
	C1605.430420,445.502258 1597.207153,469.724182 1573.259033,484.931335 
	C1560.873291,492.796326 1547.134399,496.493073 1532.469727,497.030426 
	C1517.460327,497.580475 1502.995850,495.869202 1489.281006,489.084503 
	C1469.020020,479.061615 1457.266968,462.643951 1452.010986,441.086395 
	C1451.327148,438.281128 1450.784180,435.441437 1450.110107,432.312256 
	C1458.190674,432.312256 1466.251099,432.312256 1474.694092,432.312256 
	C1476.974487,441.225372 1480.101074,449.958160 1485.993408,457.698883 
	C1492.419067,466.140167 1500.935059,471.155853 1510.676880,473.732086 
	C1528.370972,478.411224 1545.499878,476.573792 1560.890991,465.941498 
	C1569.234009,460.178162 1574.845825,451.948242 1575.853271,441.859802 
	C1578.217285,418.188416 1568.293213,403.481049 1545.492554,396.054718 
	C1531.318848,391.438324 1516.889282,387.603180 1502.736450,382.927612 
	C1490.677368,378.943756 1479.461670,373.088440 1470.486450,363.886444 
	C1461.667603,354.844574 1457.537476,343.708557 1456.946655,331.075165 
	C1456.334351,317.982666 1459.048950,305.899475 1467.031860,295.369598 
	C1470.005981,291.446503 1473.687622,288.059753 1477.317383,284.185974 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1209.302490,573.014709 
	C1218.386841,572.334839 1227.076782,570.796387 1235.687256,571.157471 
	C1266.150146,572.434753 1291.351196,590.603760 1297.007080,623.382935 
	C1297.413452,625.738770 1297.875488,628.084961 1298.373291,630.767822 
	C1290.010498,630.767822 1282.243896,630.767822 1274.346436,630.767822 
	C1272.510864,616.242798 1265.697998,604.493958 1252.807861,597.604980 
	C1243.829224,592.806335 1233.913574,590.993469 1223.205200,592.686584 
	C1214.838013,594.009460 1207.316040,596.150024 1200.380371,601.014282 
	C1193.926270,605.540771 1190.383667,611.741516 1188.398560,619.089600 
	C1185.314819,630.504700 1187.004272,641.051270 1195.058960,649.908264 
	C1201.842651,657.367737 1211.067749,660.978149 1220.422363,663.948181 
	C1234.625488,668.457397 1249.079712,672.216919 1263.147949,677.099609 
	C1280.272339,683.042969 1295.324829,692.346985 1302.387207,710.050110 
	C1310.802734,731.144592 1309.140503,751.918396 1295.726074,770.531738 
	C1283.003784,788.184937 1264.391724,795.536560 1243.229858,798.134827 
	C1226.433716,800.197083 1210.500854,798.004700 1195.300293,790.967896 
	C1174.257568,781.226624 1162.497559,763.971375 1157.035400,741.961304 
	C1156.349609,739.197815 1156.150391,736.313538 1155.652954,733.001465 
	C1163.467163,733.001465 1170.603394,732.829102 1177.714233,733.175232 
	C1178.866455,733.231262 1180.509766,735.427979 1180.901978,736.906799 
	C1183.683716,747.396118 1187.837402,757.111694 1196.066284,764.529602 
	C1204.628418,772.247925 1214.781860,776.145874 1226.295410,777.070435 
	C1236.745483,777.909729 1246.837036,777.028381 1256.579102,773.000244 
	C1270.877319,767.088379 1279.825439,756.443481 1281.797363,741.259399 
	C1283.711914,726.517395 1278.410034,714.225159 1265.877686,705.260620 
	C1255.788330,698.043518 1243.953857,695.700989 1232.565186,691.934021 
	C1219.352905,687.563904 1205.934692,683.511841 1193.292236,677.802124 
	C1178.256348,671.011353 1167.198364,659.554810 1163.535400,642.912903 
	C1159.396973,624.111450 1162.956055,606.954651 1176.223267,592.134644 
	C1185.156128,582.156311 1196.640991,577.086365 1209.302490,573.014709 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1100.035156,492.999512 
	C1096.893311,492.999512 1094.245850,492.999512 1091.250122,492.999512 
	C1091.250122,483.403198 1091.250122,473.987701 1091.250122,463.466614 
	C1083.913574,473.566803 1075.877930,481.310913 1065.748169,486.814331 
	C1056.123169,492.043457 1045.982056,494.881500 1035.073853,496.159851 
	C1021.794128,497.716156 1009.260742,495.596313 996.987793,490.993439 
	C980.653809,484.867493 968.474182,473.644196 959.535034,458.952240 
	C950.018494,443.311157 946.369751,426.020599 948.140198,407.939270 
	C949.732544,391.677429 955.119263,376.710419 965.657837,363.672791 
	C976.021667,350.851288 988.771118,341.924347 1004.636108,337.872070 
	C1030.033325,331.385040 1053.883545,334.610321 1075.208252,350.761597 
	C1080.489624,354.761688 1085.459717,359.172668 1089.620728,362.608490 
	C1089.620728,356.517029 1089.620728,348.046051 1089.620728,339.292297 
	C1098.273682,339.292297 1106.345459,339.292297 1114.710083,339.292297 
	C1114.710083,390.276367 1114.710083,441.339050 1114.710083,492.999512 
	C1110.053955,492.999512 1105.291748,492.999512 1100.035156,492.999512 
M997.023438,366.461792 
	C992.675354,371.050415 987.657349,375.176758 984.109741,380.317780 
	C974.948425,393.594086 971.566589,408.373413 973.925171,424.553314 
	C976.387573,441.445831 983.686279,455.404938 997.770325,465.197845 
	C1009.518799,473.366791 1022.522522,476.798859 1037.117554,475.165802 
	C1051.107910,473.600403 1063.070557,468.137634 1072.802734,458.478638 
	C1085.019531,446.353577 1090.218506,430.829102 1089.751221,413.904846 
	C1089.537842,406.174042 1087.698120,398.089844 1084.773071,390.908478 
	C1076.681885,371.043762 1057.496582,358.000977 1036.884888,356.087372 
	C1022.763367,354.776276 1009.467407,357.856384 997.023438,366.461792 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1884.386230,650.219421 
	C1896.557251,642.944092 1908.880981,637.974121 1923.036377,636.783203 
	C1947.340088,634.738586 1968.007202,641.862366 1985.661987,658.278198 
	C1988.420898,660.843384 1990.442627,664.201111 1993.729980,668.363220 
	C1993.729980,658.117371 1993.729980,649.297485 1993.729980,640.245361 
	C2002.039185,640.245361 2009.776611,640.245361 2017.758179,640.245361 
	C2017.758179,691.375549 2017.758179,742.440735 2017.758179,793.753113 
	C2009.965576,793.753113 2002.228027,793.753113 1994.170166,793.753113 
	C1994.170166,785.264771 1994.170166,776.824768 1994.170166,767.077393 
	C1992.329590,768.577820 1991.114380,769.247864 1990.331665,770.254395 
	C1978.276367,785.754578 1962.275879,794.098938 1943.044312,797.068115 
	C1930.690430,798.975464 1918.513672,798.497559 1906.652466,794.889404 
	C1896.276978,791.733215 1886.863403,786.616394 1878.622192,779.251038 
	C1865.812622,767.802917 1857.658081,753.820312 1853.594360,737.212402 
	C1849.156006,719.072266 1851.027710,701.597168 1857.901611,684.352356 
	C1863.431274,670.480347 1872.573120,659.587097 1884.386230,650.219421 
M1992.000366,705.602966 
	C1991.667969,704.195923 1991.334961,702.789001 1991.002808,701.381836 
	C1983.337036,668.905884 1951.266724,652.316589 1922.625000,658.383667 
	C1895.573242,664.113831 1880.693237,682.454163 1877.308838,708.661743 
	C1874.313965,731.852661 1881.488403,752.143250 1901.195068,766.743164 
	C1919.780518,780.512390 1945.446411,779.958435 1964.032349,769.329346 
	C1976.012573,762.478027 1984.687744,752.367493 1989.340820,739.176086 
	C1993.092651,728.539795 1994.304077,717.648865 1992.000366,705.602966 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M2181.804688,360.307678 
	C2189.991211,370.712158 2196.192871,381.813721 2198.094482,394.641205 
	C2199.603027,404.818237 2199.921143,415.171783 2200.805420,425.900391 
	C2155.287354,425.900391 2110.887451,425.900391 2065.865234,425.900391 
	C2066.530029,435.446869 2069.396240,443.784973 2074.074707,451.543060 
	C2081.960449,464.619293 2093.617920,472.832489 2108.416992,475.612915 
	C2130.896484,479.836365 2151.349121,474.857941 2167.235107,457.809357 
	C2172.088867,452.600525 2176.281982,450.047363 2183.162842,450.897430 
	C2187.587158,451.444000 2192.134033,451.000000 2197.967529,451.000000 
	C2194.232910,456.751312 2191.424316,462.152130 2187.625977,466.732727 
	C2174.123779,483.016693 2156.511719,492.811432 2135.778809,495.792847 
	C2114.565186,498.843353 2093.857666,495.912720 2075.569092,483.885315 
	C2056.616943,471.421661 2045.522461,453.764954 2041.816040,431.052643 
	C2038.177124,408.754150 2041.641846,388.204834 2054.019531,369.385010 
	C2066.604248,350.250397 2084.501953,339.283875 2107.196777,335.966278 
	C2126.069580,333.207397 2144.361084,335.078888 2161.148438,344.238525 
	C2168.606201,348.307739 2174.795898,354.701355 2181.804688,360.307678 
M2101.773926,357.029388 
	C2079.551025,365.719879 2068.474609,382.746338 2065.246094,405.791809 
	C2102.132324,405.791809 2138.907715,405.791809 2175.687500,405.791809 
	C2174.900391,371.347412 2141.518311,344.406311 2101.773926,357.029388 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1632.994141,371.080811 
	C1638.973877,363.138245 1645.075439,355.900146 1653.088013,350.144745 
	C1663.297119,342.811493 1674.555908,338.187622 1686.600464,336.206329 
	C1703.513428,333.424225 1720.344604,334.244751 1736.648315,340.870209 
	C1750.537842,346.514557 1762.083862,354.838959 1771.025513,366.923950 
	C1783.133545,383.288422 1788.481323,401.807953 1786.818604,421.790009 
	C1784.560791,448.923370 1771.971680,470.482727 1748.404663,484.885193 
	C1737.087158,491.801544 1724.633179,494.842163 1711.364380,496.228119 
	C1694.980469,497.939331 1679.605713,494.990204 1665.060791,488.348694 
	C1646.598633,479.918549 1633.857178,465.445465 1626.034790,446.745178 
	C1621.589722,436.118378 1619.621704,424.936920 1620.057861,413.461151 
	C1620.631470,398.366119 1624.425293,384.153503 1632.994141,371.080811 
M1707.281250,356.000031 
	C1702.702759,356.333099 1698.097168,356.454163 1693.550903,357.037964 
	C1678.186890,359.010773 1666.165894,366.944336 1657.078735,379.067291 
	C1646.335815,393.399323 1642.643433,409.706329 1646.032104,427.358826 
	C1651.030884,453.399353 1668.885620,471.351990 1694.990845,474.731812 
	C1716.938599,477.573364 1736.342285,471.202271 1750.138062,452.383270 
	C1761.842896,436.416229 1764.712158,418.819397 1760.000122,399.812469 
	C1757.293335,388.893555 1751.963745,379.196747 1743.856567,371.586914 
	C1733.976318,362.312439 1721.808594,357.286102 1707.281250,356.000031 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1592.042847,636.886230 
	C1625.206787,637.548401 1655.369629,659.890747 1665.082153,692.433289 
	C1673.304443,719.982666 1668.934448,745.294922 1651.379150,768.026672 
	C1638.043457,785.294678 1619.997803,794.210938 1598.467896,797.117859 
	C1580.193726,799.585266 1562.614258,797.654175 1546.211670,789.498108 
	C1523.635010,778.272095 1509.289185,759.888977 1504.109985,735.186401 
	C1497.527344,703.788818 1506.520264,676.901978 1530.260132,655.434937 
	C1540.802856,645.901550 1553.678467,640.275513 1567.832275,638.036743 
	C1571.534180,637.451111 1575.309204,637.327759 1579.726318,637.253662 
	C1584.407349,639.618164 1588.327515,640.149475 1592.042847,636.886230 
M1642.971802,731.152283 
	C1643.314697,725.416748 1644.093750,719.667664 1643.915161,713.948425 
	C1643.459961,699.378113 1638.317993,686.500427 1628.292725,675.857483 
	C1616.665039,663.513550 1602.321899,657.884338 1585.224731,657.838379 
	C1569.571899,657.796265 1556.033081,662.854614 1545.246704,673.540955 
	C1530.305176,688.344055 1524.374023,706.646484 1527.978149,727.737549 
	C1533.787964,761.737793 1564.060303,782.681396 1598.027954,775.773193 
	C1621.791626,770.940247 1636.237305,755.192871 1642.971802,731.152283 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M974.316406,728.302246 
	C973.129883,743.024292 966.971924,755.318115 958.752563,766.680847 
	C947.730896,781.917419 932.444763,791.472107 914.511719,795.558533 
	C887.033936,801.819946 860.660400,798.354065 838.021301,780.279114 
	C822.854797,768.170227 813.454651,752.142212 809.892395,732.680786 
	C806.564026,714.497681 808.595093,697.187317 816.776611,680.762573 
	C828.710388,656.805115 848.426697,643.008911 874.509155,638.000549 
	C894.741028,634.115662 914.160217,636.376770 932.543457,645.950378 
	C953.821899,657.031738 967.515808,674.416016 972.720276,697.632935 
	C974.905640,707.381592 974.055542,717.810669 974.316406,728.302246 
M856.681824,667.590759 
	C851.367554,669.799316 846.611084,672.522888 845.782104,679.764038 
	C834.417847,695.582764 830.141113,712.839172 834.983521,732.033264 
	C839.203857,748.761841 848.377441,761.852234 863.744385,769.876526 
	C875.299133,775.910217 887.583496,778.308594 900.868713,776.163086 
	C912.957703,774.210693 923.534729,769.611877 932.173828,761.194519 
	C945.639648,748.074341 951.180725,731.837036 950.056885,713.065796 
	C948.911804,693.940552 940.555908,678.802063 925.164612,667.810913 
	C911.486450,658.043091 895.820557,655.559082 879.664795,659.212585 
	C871.852722,660.979126 864.567078,665.073242 856.681824,667.590759 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M2093.808594,645.692383 
	C2105.896729,638.587219 2118.953369,635.873413 2132.281982,636.163635 
	C2160.766113,636.783997 2182.666016,653.253418 2189.853027,682.566284 
	C2191.850830,690.714294 2192.747314,699.304871 2192.862305,707.710022 
	C2193.232178,734.691895 2193.000000,761.682068 2193.000000,788.669006 
	C2193.000000,790.297180 2193.000000,791.925354 2193.000000,793.774292 
	C2184.590820,793.774292 2176.521484,793.774292 2168.000000,793.774292 
	C2168.000000,790.224976 2168.000000,786.775208 2168.000000,783.325439 
	C2168.000000,758.837280 2168.202148,734.346680 2167.904053,709.862122 
	C2167.778076,699.497070 2166.025879,689.352417 2161.061523,679.899902 
	C2155.378174,669.078247 2146.434814,662.672668 2134.865967,660.112671 
	C2120.898193,657.021851 2107.590820,659.596741 2096.102295,668.103210 
	C2083.771240,677.233521 2076.281494,689.702087 2076.098633,705.338196 
	C2075.755615,734.650330 2075.999756,763.969299 2075.999756,793.642700 
	C2067.530273,793.642700 2059.123047,793.642700 2050.356934,793.642700 
	C2050.356934,742.747986 2050.356934,691.575928 2050.356934,640.201782 
	C2058.461182,640.201782 2066.530029,640.201782 2075.154785,640.201782 
	C2075.154785,648.211548 2075.154785,656.044250 2075.154785,663.876953 
	C2080.195312,656.429626 2086.190430,650.517273 2093.808594,645.692383 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M2426.732422,457.679260 
	C2419.596924,474.209503 2412.682617,490.414459 2405.794189,506.630341 
	C2398.980713,522.670044 2392.192627,538.720642 2385.336670,554.900146 
	C2376.824707,554.900146 2368.175049,554.900146 2359.027588,554.900146 
	C2362.729248,546.210327 2366.368408,537.701843 2369.979492,529.181580 
	C2375.666260,515.764893 2381.398682,502.366821 2386.919189,488.881958 
	C2387.539795,487.366028 2387.446045,485.113800 2386.790771,483.586151 
	C2377.314209,461.498260 2367.600830,439.512146 2358.114502,417.428467 
	C2347.068604,391.714264 2336.189453,365.928436 2324.971924,339.548157 
	C2334.083496,339.548157 2342.766846,339.548157 2351.538818,339.548157 
	C2367.784912,378.807037 2384.167725,418.395874 2400.550537,457.984741 
	C2401.045898,458.155090 2401.541504,458.325439 2402.036865,458.495789 
	C2418.105957,418.718689 2434.175293,378.941589 2450.250244,339.150391 
	C2459.172119,339.150391 2467.976074,339.150391 2477.417480,339.150391 
	C2460.498779,378.790009 2443.731934,418.074432 2426.732422,457.679260 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1917.632690,467.767090 
	C1926.421997,462.041992 1933.595459,455.273560 1937.945068,445.990265 
	C1938.984253,443.772400 1940.078491,442.869293 1942.598022,442.933746 
	C1949.908203,443.120789 1957.226196,443.000031 1964.801025,443.000031 
	C1959.125366,459.153625 1949.800171,472.210693 1935.913452,482.044373 
	C1920.177612,493.187531 1902.254517,497.844635 1883.599854,496.749695 
	C1829.773438,493.590271 1807.486084,456.091400 1805.124390,424.679962 
	C1800.937134,368.991180 1836.878296,341.607513 1869.884033,336.219025 
	C1919.055420,328.191345 1954.340454,354.209808 1964.625366,388.999481 
	C1957.433960,388.999481 1950.300903,389.187836 1943.192139,388.857910 
	C1941.557007,388.782013 1939.360718,387.299316 1938.512939,385.833435 
	C1929.725464,370.640930 1916.993042,360.309692 1899.795898,357.186218 
	C1868.951904,351.584015 1841.162720,365.771362 1832.219849,398.358154 
	C1825.699585,422.117065 1830.747681,444.024658 1849.099121,461.396667 
	C1858.637817,470.426086 1870.573486,474.641571 1883.929565,475.098083 
	C1895.748413,475.502075 1906.862793,473.529419 1917.632690,467.767090 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1446.604736,789.774719 
	C1431.250000,796.798401 1415.416504,799.317627 1399.100952,797.932068 
	C1365.227905,795.055664 1336.860229,773.679688 1328.039185,738.853333 
	C1322.931641,718.688538 1324.582153,698.791870 1333.568848,680.125183 
	C1343.972900,658.513794 1361.654053,644.955566 1384.837402,639.159485 
	C1392.822144,637.163208 1401.297485,635.949341 1409.493042,636.199341 
	C1433.247437,636.924133 1454.217407,644.945007 1470.431519,663.024414 
	C1475.933594,669.159607 1483.822266,681.386963 1484.902832,689.702087 
	C1476.802124,689.702087 1468.729370,689.702087 1460.399780,689.702087 
	C1451.537964,671.244202 1436.230713,660.497559 1416.095825,658.214966 
	C1385.630493,654.761047 1362.052368,669.169434 1353.170776,699.181519 
	C1347.109863,719.662170 1350.568848,739.030090 1363.772583,756.304443 
	C1372.853149,768.184326 1385.126221,773.814453 1399.629517,776.128052 
	C1415.182251,778.608948 1429.212280,775.167175 1442.214233,766.920532 
	C1450.078735,761.932434 1455.020874,754.199829 1459.933838,746.503235 
	C1460.703491,745.297607 1462.584595,744.162415 1463.992188,744.111511 
	C1470.803345,743.865295 1477.628296,744.000549 1484.427490,744.000549 
	C1485.287598,753.373352 1470.237549,777.493774 1446.604736,789.774719 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1011.000000,767.000000 
	C1011.000000,731.531189 1011.000000,696.562378 1011.000000,661.196106 
	C1001.406250,661.196106 991.996277,661.196106 982.295837,661.196106 
	C982.295837,654.070007 982.295837,647.330505 982.295837,640.189941 
	C991.600403,640.189941 1001.010254,640.189941 1011.000244,640.189941 
	C1011.000244,632.377441 1010.556519,624.915283 1011.097717,617.525269 
	C1012.057190,604.424805 1014.947388,591.855469 1025.133545,582.409790 
	C1032.875366,575.230652 1042.335693,572.219055 1052.700684,570.879700 
	C1062.253662,569.645203 1071.602661,569.916016 1080.906738,572.096924 
	C1082.095581,572.375549 1083.815674,573.937012 1083.860596,574.966553 
	C1084.135620,581.260010 1083.998047,587.571411 1083.998047,592.995850 
	C1074.858032,592.995850 1066.111206,592.580261 1057.420166,593.097412 
	C1045.659424,593.797119 1038.933228,602.929382 1037.064087,613.805664 
	C1036.346069,617.983765 1036.201782,622.277954 1036.036621,626.528564 
	C1035.869385,630.829468 1035.999756,635.141907 1035.999756,640.000427 
	C1043.826904,640.000427 1051.426880,640.000427 1059.026855,640.000427 
	C1066.500244,640.000427 1073.973511,640.000427 1081.722168,640.000427 
	C1081.722168,646.970032 1081.722168,653.708069 1081.722168,660.844727 
	C1066.694336,660.844727 1051.621460,660.844727 1036.166992,660.844727 
	C1036.166992,705.299927 1036.166992,749.362732 1036.166992,793.712158 
	C1027.717529,793.712158 1019.646118,793.712158 1011.000000,793.712158 
	C1011.000000,785.026428 1011.000000,776.263184 1011.000000,767.000000 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1675.000366,646.084778 
	C1675.000366,643.944031 1675.000366,642.291199 1675.000366,640.237305 
	C1685.553955,640.237305 1695.964600,640.237305 1706.771973,640.237305 
	C1706.771973,623.770203 1706.771973,607.694641 1706.771973,591.311157 
	C1715.235962,591.311157 1723.309814,591.311157 1731.787354,591.311157 
	C1731.787354,607.246643 1731.787354,623.322205 1731.787354,639.795898 
	C1747.586670,639.795898 1762.995728,639.795898 1778.700562,639.795898 
	C1778.700562,646.926270 1778.700562,653.667114 1778.700562,660.812073 
	C1763.395142,660.812073 1747.986084,660.812073 1732.251099,660.812073 
	C1732.153931,662.625244 1732.010498,664.060608 1732.009766,665.496094 
	C1731.996582,693.494812 1731.826782,721.495544 1732.155884,749.490417 
	C1732.216797,754.666260 1733.760010,760.021606 1735.587280,764.933838 
	C1738.353516,772.370117 1744.540283,775.892334 1752.268188,775.911316 
	C1760.392578,775.931335 1768.518555,775.244019 1776.811035,774.858032 
	C1776.811035,781.030212 1776.811035,787.816040 1776.811035,794.798401 
	C1763.322632,797.959045 1750.008301,799.499695 1736.202881,796.178101 
	C1721.496582,792.639771 1713.561035,782.848450 1710.218994,769.238403 
	C1708.062622,760.456116 1707.268311,751.170105 1707.137695,742.091492 
	C1706.752075,715.278381 1707.000000,688.456238 1707.000000,661.236694 
	C1696.448730,661.236694 1686.037476,661.236694 1675.000366,661.236694 
	C1675.000366,656.090149 1675.000366,651.331421 1675.000366,646.084778 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M2242.000000,413.000000 
	C2242.000000,395.192963 2242.000000,377.885925 2242.000000,360.180969 
	C2231.391602,360.180969 2220.982422,360.180969 2210.289062,360.180969 
	C2210.289062,353.052917 2210.289062,346.313904 2210.289062,339.173248 
	C2220.618408,339.173248 2231.027344,339.173248 2241.827637,339.173248 
	C2241.827637,322.711182 2241.827637,306.638611 2241.827637,290.284790 
	C2250.287842,290.284790 2258.359619,290.284790 2266.830566,290.284790 
	C2266.830566,306.291748 2266.830566,322.364319 2266.830566,338.829956 
	C2282.290283,338.829956 2297.363525,338.829956 2312.716309,338.829956 
	C2312.716309,345.956848 2312.716309,352.695587 2312.716309,359.834167 
	C2297.704590,359.834167 2282.631348,359.834167 2267.253174,359.834167 
	C2267.153809,361.478455 2267.010010,362.749512 2267.009521,364.020630 
	C2266.996826,392.179108 2266.856201,420.338837 2267.104492,448.495117 
	C2267.163818,455.226624 2268.108887,462.000061 2272.980713,467.523438 
	C2280.361816,475.892029 2290.002441,475.481598 2299.693115,474.616699 
	C2303.656982,474.262939 2307.543945,473.045593 2311.998291,472.109192 
	C2311.998291,478.402802 2312.087158,484.662292 2311.900635,490.913605 
	C2311.873291,491.833130 2310.653809,493.360382 2309.792236,493.512756 
	C2300.596191,495.139160 2291.574463,498.449951 2281.947021,496.099396 
	C2278.031006,495.143250 2273.804443,495.412689 2269.922607,494.368439 
	C2254.174805,490.131836 2247.145020,478.401215 2243.990479,463.464691 
	C2240.496094,446.916595 2242.571289,430.158051 2242.000000,413.000000 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M810.000488,274.166809 
	C817.806885,274.166809 825.613281,274.166809 834.002869,274.166809 
	C834.002869,339.128326 834.002869,404.045654 834.058228,469.825073 
	C836.065430,471.458069 838.014221,472.891846 839.969666,472.900879 
	C870.587158,473.042358 901.205505,473.016205 931.823547,472.957306 
	C933.549622,472.954010 935.274536,472.333344 937.348022,472.056152 
	C940.095947,474.264893 941.541382,476.696228 940.000000,480.444153 
	C940.000000,483.258881 940.000000,485.629425 940.000000,488.333313 
	C940.000000,489.111115 940.000000,489.555542 939.584534,490.052917 
	C937.216125,490.403870 935.263550,490.959259 933.310181,490.961884 
	C895.170105,491.013092 857.029968,491.008026 818.889832,490.993408 
	C811.038208,490.990387 810.000977,489.909821 810.000854,482.022186 
	C809.999451,412.737061 810.000366,343.451935 810.000488,274.166809 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1803.000000,661.000000 
	C1803.000000,630.525269 1803.000000,600.550476 1803.000000,570.288330 
	C1811.283203,570.288330 1819.355713,570.288330 1827.715576,570.288330 
	C1827.715576,644.625244 1827.715576,719.024658 1827.715576,793.712158 
	C1819.716064,793.712158 1811.643311,793.712158 1803.000000,793.712158 
	C1803.000000,749.684509 1803.000000,705.592224 1803.000000,661.000000 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M2015.000000,379.000000 
	C2015.000000,417.139832 2015.000000,454.779663 2015.000000,492.709290 
	C2006.722412,492.709290 1998.649780,492.709290 1990.286987,492.709290 
	C1990.286987,441.714264 1990.286987,390.647491 1990.286987,339.290100 
	C1998.277710,339.290100 2006.350342,339.290100 2015.000000,339.290100 
	C2015.000000,352.307495 2015.000000,365.403748 2015.000000,379.000000 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M2014.230957,316.278625 
	C2007.950928,321.387054 2001.035034,321.400421 1994.576172,318.651398 
	C1988.209473,315.941711 1985.660400,309.901917 1986.066772,303.092834 
	C1986.527954,295.364319 1990.781494,290.548767 1999.156494,288.416626 
	C2004.795532,286.981079 2011.842773,288.529144 2016.372681,294.984161 
	C2019.593262,299.573578 2020.771240,308.072205 2016.062256,313.580750 
	C2015.443848,314.304077 2015.015503,315.189880 2014.230957,316.278625 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M809.563843,274.098053 
	C810.000366,343.451935 809.999451,412.737061 810.000854,482.022186 
	C810.000977,489.909821 811.038208,490.990387 818.889832,490.993408 
	C857.029968,491.008026 895.170105,491.013092 933.310181,490.961884 
	C935.263550,490.959259 937.216125,490.403870 940.021240,489.704102 
	C941.106628,489.011658 941.339844,488.721039 941.573059,488.430420 
	C941.700806,488.657379 941.828613,488.884308 941.637878,489.796417 
	C941.205200,490.718292 941.091064,490.954987 940.976868,491.191681 
	C939.219910,491.794434 937.464233,492.919281 935.705872,492.923401 
	C893.888733,493.021179 852.071289,492.998596 810.253906,492.997894 
	C809.631775,492.997864 809.009644,492.997864 808.000000,492.997864 
	C808.000000,490.986298 808.000000,489.364624 808.000000,487.742920 
	C808.000000,418.269440 807.991760,348.795959 808.047241,279.322510 
	C808.048645,277.557800 808.751404,275.793671 809.563843,274.098053 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M937.000000,472.000000 
	C935.274536,472.333344 933.549622,472.954010 931.823547,472.957306 
	C901.205505,473.016205 870.587158,473.042358 839.969666,472.900879 
	C838.014221,472.891846 836.065430,471.458069 834.077820,470.286133 
	C868.052673,469.927460 902.063232,469.969757 936.536865,470.394958 
	C937.000000,471.185242 937.000000,471.592621 937.000000,472.000000 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M1591.831299,636.512695 
	C1588.327515,640.149475 1584.407349,639.618164 1580.177856,637.202637 
	C1583.842407,636.639832 1587.731079,636.389526 1591.831299,636.512695 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M937.348022,472.056152 
	C937.000000,471.592621 937.000000,471.185242 936.999817,470.472351 
	C940.822571,470.249847 942.333923,472.134399 942.057129,475.984070 
	C941.787537,479.734558 941.986572,483.518768 941.705566,487.260559 
	C940.954224,484.821930 940.477112,482.410980 940.000000,480.000000 
	C941.541382,476.696228 940.095947,474.264893 937.348022,472.056152 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M940.000000,480.444153 
	C940.477112,482.410980 940.954224,484.821930 941.580872,487.801300 
	C941.730469,488.369690 941.716370,488.373840 941.279114,488.262726 
	C940.561218,488.101074 940.280579,488.050537 940.000000,488.000000 
	C940.000000,485.629425 940.000000,483.258881 940.000000,480.444153 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M940.000000,488.333313 
	C940.280579,488.050537 940.561218,488.101074 941.251831,488.276611 
	C941.661804,488.401581 941.490967,488.426025 941.531982,488.428223 
	C941.339844,488.721039 941.106628,489.011658 940.436707,489.651154 
	C940.000000,489.555542 940.000000,489.111115 940.000000,488.333313 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M941.196899,491.112183 
	C941.091064,490.954987 941.205200,490.718292 941.575928,490.182129 
	C941.693909,490.266052 941.555420,490.649384 941.196899,491.112183 
z"
    />
    <path
      opacity="1.000000"
      stroke="none"
      d="
M2356.299072,736.286987 
	C2350.089111,756.820129 2336.407959,769.367798 2316.530029,774.870117 
	C2298.583008,779.837830 2281.443115,777.397522 2266.213623,765.992676 
	C2253.686035,756.611389 2246.590088,743.949768 2243.957764,728.557434 
	C2241.395508,713.576050 2243.603027,699.508667 2250.971680,686.215027 
	C2260.266846,669.446106 2274.471680,660.302490 2293.464111,657.930298 
	C2309.010010,655.988586 2322.829834,659.810303 2335.417725,668.834167 
	C2347.579590,677.552734 2355.156494,689.332092 2357.911133,703.939636 
	C2359.926270,714.625854 2359.990723,725.413086 2356.299072,736.286987 
z"
    />
    <path
      opacity="1.000000"
      stroke="none"
      d="
M997.296692,366.208496 
	C1009.467407,357.856384 1022.763367,354.776276 1036.884888,356.087372 
	C1057.496582,358.000977 1076.681885,371.043762 1084.773071,390.908478 
	C1087.698120,398.089844 1089.537842,406.174042 1089.751221,413.904846 
	C1090.218506,430.829102 1085.019531,446.353577 1072.802734,458.478638 
	C1063.070557,468.137634 1051.107910,473.600403 1037.117554,475.165802 
	C1022.522522,476.798859 1009.518799,473.366791 997.770325,465.197845 
	C983.686279,455.404938 976.387573,441.445831 973.925171,424.553314 
	C971.566589,408.373413 974.948425,393.594086 984.109741,380.317780 
	C987.657349,375.176758 992.675354,371.050415 997.296692,366.208496 
z"
    />
    <path
      opacity="1.000000"
      stroke="none"
      d="
M1992.002441,706.049438 
	C1994.304077,717.648865 1993.092651,728.539795 1989.340820,739.176086 
	C1984.687744,752.367493 1976.012573,762.478027 1964.032349,769.329346 
	C1945.446411,779.958435 1919.780518,780.512390 1901.195068,766.743164 
	C1881.488403,752.143250 1874.313965,731.852661 1877.308838,708.661743 
	C1880.693237,682.454163 1895.573242,664.113831 1922.625000,658.383667 
	C1951.266724,652.316589 1983.337036,668.905884 1991.002808,701.381836 
	C1991.334961,702.789001 1991.667969,704.195923 1992.002441,706.049438 
z"
    />
    <path
      opacity="1.000000"
      stroke="none"
      d="
M2102.187988,357.013733 
	C2141.518311,344.406311 2174.900391,371.347412 2175.687500,405.791809 
	C2138.907715,405.791809 2102.132324,405.791809 2065.246094,405.791809 
	C2068.474609,382.746338 2079.551025,365.719879 2102.187988,357.013733 
z"
    />
    <path
      opacity="1.000000"
      stroke="none"
      d="
M1707.749268,356.000092 
	C1721.808594,357.286102 1733.976318,362.312439 1743.856567,371.586914 
	C1751.963745,379.196747 1757.293335,388.893555 1760.000122,399.812469 
	C1764.712158,418.819397 1761.842896,436.416229 1750.138062,452.383270 
	C1736.342285,471.202271 1716.938599,477.573364 1694.990845,474.731812 
	C1668.885620,471.351990 1651.030884,453.399353 1646.032104,427.358826 
	C1642.643433,409.706329 1646.335815,393.399323 1657.078735,379.067291 
	C1666.165894,366.944336 1678.186890,359.010773 1693.550903,357.037964 
	C1698.097168,356.454163 1702.702759,356.333099 1707.749268,356.000092 
z"
    />
    <path
      opacity="1.000000"
      stroke="none"
      d="
M1642.779541,731.541443 
	C1636.237305,755.192871 1621.791626,770.940247 1598.027954,775.773193 
	C1564.060303,782.681396 1533.787964,761.737793 1527.978149,727.737549 
	C1524.374023,706.646484 1530.305176,688.344055 1545.246704,673.540955 
	C1556.033081,662.854614 1569.571899,657.796265 1585.224731,657.838379 
	C1602.321899,657.884338 1616.665039,663.513550 1628.292725,675.857483 
	C1638.317993,686.500427 1643.459961,699.378113 1643.915161,713.948425 
	C1644.093750,719.667664 1643.314697,725.416748 1642.779541,731.541443 
z"
    />
    <path
      opacity="1.000000"
      stroke="none"
      d="
M857.043091,668.113525 
	C864.567078,665.073242 871.852722,660.979126 879.664795,659.212585 
	C895.820557,655.559082 911.486450,658.043091 925.164612,667.810913 
	C940.555908,678.802063 948.911804,693.940552 950.056885,713.065796 
	C951.180725,731.837036 945.639648,748.074341 932.173828,761.194519 
	C923.534729,769.611877 912.957703,774.210693 900.868713,776.163086 
	C887.583496,778.308594 875.299133,775.910217 863.744385,769.876526 
	C848.377441,761.852234 839.203857,748.761841 834.983521,732.033264 
	C830.141113,712.839172 834.417847,695.582764 846.235718,679.306335 
	C850.140625,675.270264 853.591858,671.691895 857.043091,668.113525 
z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M856.862427,667.852173 
	C853.591858,671.691895 850.140625,675.270264 846.366211,678.981079 
	C846.611084,672.522888 851.367554,669.799316 856.862427,667.852173 
z"
    />
  </svg>
</div>
